export * from './AttachPaperclipIcon';
export * from './AttachPaperclipIcon16Light';
export * from './AttachPaperclipIcon16Regular';
export * from './AttachPaperclipIcon16Solid';
export * from './AttachPaperclipIcon20Light';
export * from './AttachPaperclipIcon20Regular';
export * from './AttachPaperclipIcon20Solid';
export * from './AttachPaperclipIcon24Regular';
export * from './AttachPaperclipIcon24Solid';
export * from './AttachPaperclipIcon32Regular';
export * from './AttachPaperclipIcon64Regular';
